export const crudResources = {
  cities: {
    title: 'Cities List',
    singular: 'City',
    description: '',
    focusField: 'name',
    compactDialog: true,
    columns: [['name', 'City'], ['isActive', 'Active']],
    fields: [
      { name: 'name', label: 'City Name', required: true, topMargin: '10px' },
      { name: 'isActive', label: 'Active', type: 'boolean', default: true }
    ]
  },
  areas: {
    title: 'Areas List',
    singular: 'Area',
    description: '',
    focusField: 'cityId',
    compactDialog: true,
    columns: [['cityName', 'City'], ['name', 'Area'], ['isActive', 'Active']],
    fields: [
      { name: 'cityId', label: 'City', type: 'select', resource: 'cities', optionLabel: 'name', required: true, topMargin: '10px' },
      { name: 'name', label: 'Area Name', required: true, topMargin: '10px' },
      { name: 'isActive', label: 'Active', type: 'boolean', default: true }
    ]
  },
  customers: {
    title: 'Customers List',
    singular: 'Customer',
    description: '',
    focusField: 'name',
    searchPlaceholder: 'Search code, name, or mobile',
    searchFields: ['customerCode', 'name', 'mobile', 'cityName', 'cnic', 'ntn'],
    columns: [
      ['customerCode', 'Code'], ['name', 'Name'], ['mobile', 'Mobile'],
      ['cityName', 'City'], ['paymentTerms', 'Payment Terms'], ['taxType', 'Tax Type'],
      ['balance', 'Balance']
    ],
    fields: [
      { name: 'name', label: 'Customer Name', required: true, topMargin: '10px' },
      { name: 'mobile', label: 'Mobile', topMargin: '10px' },
      { name: 'email', label: 'Email', type: 'email' },
      { name: 'cnic', label: 'CNIC' },
      { name: 'address', label: 'Address', type: 'multiline', span: 12 },
      { name: 'cityId', label: 'City', type: 'select', resource: 'cities', optionLabel: 'name' },
      {
        name: 'areaId', label: 'Area', type: 'select', resource: 'areas', optionLabel: 'name',
        dependsOn: 'cityId', optionForeignKey: 'cityId'
      },
      { name: 'ntn', label: 'NTN' },
      { name: 'strn', label: 'STRN' },
      {
        name: 'paymentTerms', label: 'Payment Terms', type: 'select', required: true, default: 'Cash',
        options: ['Cash', 'Credit', 'Sale Base'], focusTarget: 'creditDays', focusWhen: 'Credit'
      },
      {
        name: 'creditDays', label: 'Credit Days', type: 'number', default: '',
        visibleWhen: { field: 'paymentTerms', equals: 'Credit' },
        requiredWhen: { field: 'paymentTerms', equals: 'Credit' }
      },
      {
        name: 'taxType', label: 'Tax Type', type: 'select', required: true, default: 'R',
        options: [
          { value: 'R', label: 'Register' },
          { value: 'N', label: 'Non Register' }
        ]
      },
      { name: 'openingBalance', label: 'Opening Balance', type: 'number', required: true, default: 0 },
      { name: 'balance', label: 'Balance', type: 'number', readOnly: true, default: 0 }
    ]
  },
  suppliers: {
    title: 'Suppliers List',
    singular: 'Supplier',
    description: '',
    focusField: 'name',
    searchPlaceholder: 'Search code, name, or mobile',
    searchFields: ['supplierCode', 'name', 'mobile', 'cityName', 'cnic', 'ntn'],
    columns: [
      ['supplierCode', 'Code'], ['name', 'Name'], ['mobile', 'Mobile'],
      ['cityName', 'City'], ['paymentTerms', 'Payment Terms'], ['taxType', 'Tax Type'],
      ['balance', 'Balance']
    ],
    fields: [
      { name: 'name', label: 'Supplier Name', required: true, topMargin: '10px' },
      { name: 'mobile', label: 'Mobile', topMargin: '10px' },
      { name: 'email', label: 'Email', type: 'email' },
      { name: 'cnic', label: 'CNIC' },
      { name: 'address', label: 'Address', type: 'multiline', span: 12 },
      { name: 'cityId', label: 'City', type: 'select', resource: 'cities', optionLabel: 'name' },
      {
        name: 'areaId', label: 'Area', type: 'select', resource: 'areas', optionLabel: 'name',
        dependsOn: 'cityId', optionForeignKey: 'cityId'
      },
      { name: 'ntn', label: 'NTN' },
      { name: 'strn', label: 'STRN' },
      {
        name: 'paymentTerms', label: 'Payment Terms', type: 'select', required: true, default: 'Cash',
        options: ['Cash', 'Credit', 'Sale Base'], focusTarget: 'creditDays', focusWhen: 'Credit'
      },
      {
        name: 'creditDays', label: 'Credit Days', type: 'number', default: '',
        visibleWhen: { field: 'paymentTerms', equals: 'Credit' },
        requiredWhen: { field: 'paymentTerms', equals: 'Credit' }
      },
      {
        name: 'taxType', label: 'Tax Type', type: 'select', required: true, default: 'R',
        options: [
          { value: 'R', label: 'Register' },
          { value: 'N', label: 'Non Register' }
        ]
      },
      { name: 'openingBalance', label: 'Opening Balance', type: 'number', required: true, default: 0 },
      { name: 'balance', label: 'Balance', type: 'number', readOnly: true, default: 0 }
    ]
  },
  schools: {
    title: 'Schools',
    singular: 'School',
    description: 'School customers and their linked buying organizations',
    columns: [
      ['schoolCode', 'Code'], ['name', 'Name'], ['customerName', 'Customer'],
      ['contactPerson', 'Contact Person'], ['phone', 'Phone'], ['isActive', 'Active']
    ],
    fields: [
      { name: 'schoolCode', label: 'School Code', required: true },
      { name: 'name', label: 'School Name', required: true },
      { name: 'customerId', label: 'Customer', type: 'select', resource: 'customers', optionLabel: 'name' },
      { name: 'contactPerson', label: 'Contact Person' },
      { name: 'phone', label: 'Phone' },
      { name: 'address', label: 'Address', type: 'multiline', span: 12 },
      { name: 'isActive', label: 'Active', type: 'boolean', default: true }
    ]
  },
  categories: {
    title: 'Categories List',
    singular: 'Category',
    description: '',
    focusField: 'name',
    compactDialog: true,
    columns: [['name', 'Category'], ['isActive', 'Active']],
    fields: [
      { name: 'name', label: 'Category Name', required: true, topMargin: '10px' },
      { name: 'isActive', label: 'Active', type: 'boolean', default: true }
    ]
  },
  sizes: {
    title: 'Sizes List',
    singular: 'Size',
    description: '',
    focusField: 'name',
    compactDialog: true,
    listReorder: 'sortOrder',
    columns: [['sortOrder', 'Order'], ['name', 'Size'], ['isActive', 'Active']],
    fields: [
      { name: 'name', label: 'Size Name', required: true, topMargin: '10px' },
      { name: 'sortOrder', label: 'Display Order', type: 'number', required: true, default: 0 },
      { name: 'isActive', label: 'Active', type: 'boolean', default: true }
    ]
  },
  colors: {
    title: 'Colors List',
    singular: 'Color',
    description: '',
    focusField: 'name',
    compactDialog: true,
    listReorder: 'sortOrder',
    columns: [['sortOrder', 'Order'], ['name', 'Color'], ['isActive', 'Active']],
    fields: [
      { name: 'name', label: 'Color Name', required: true, topMargin: '10px' },
      { name: 'sortOrder', label: 'Display Order', type: 'number', required: true, default: 0 },
      { name: 'isActive', label: 'Active', type: 'boolean', default: true }
    ]
  },
  products: {
    title: 'Product List',
    singular: 'Product',
    description: '',
    focusField: 'categoryId',
    searchPlaceholder: 'Search barcode, name, category, or supplier',
    searchFields: ['sku', 'name', 'categoryName', 'supplierName', 'unit'],
    filters: [
      { name: 'categoryId', label: 'Category', resource: 'categories', optionLabel: 'name' },
      { name: 'supplierId', label: 'Supplier', resource: 'suppliers', optionLabel: 'name' },
      {
        name: 'isActive', label: 'Status',
        options: [
          { value: 'true', label: 'Active' },
          { value: 'false', label: 'Inactive' }
        ]
      }
    ],
    columns: [
      ['sku', 'Barcode'], ['name', 'Name'], ['categoryName', 'Category'], ['unit', 'Unit'],
      ['unitCost', 'Unit Cost'],
      ['masterRate', 'Master Rate'], ['stitchingRate', 'Stitching Rate'],
      ['pressRate', 'Press Rate'], ['packingRate', 'Packing Rate'],
      ['unitRetail', 'Unit Retail']
    ],
    validate(form) {
      const masterRate = Number(form.masterRate ?? 0);
      const stitchingRate = Number(form.stitchingRate ?? 0);
      const pressRate = Number(form.pressRate ?? 0);
      const packingRate = Number(form.packingRate ?? 0);
      const unitRetail = Number(form.unitRetail ?? 0);
      const ratesSum = masterRate + stitchingRate + pressRate + packingRate;
      if (unitRetail < ratesSum) {
        return `Unit Retail cannot be less than the sum of Master, Stitching, Press, and Packing rates (${ratesSum.toFixed(2)})`;
      }
      return null;
    },
    fields: [
      { name: 'sku', label: 'Barcode', readOnly: true, default: 'Auto (000001)', topMargin: '10px' },
      { name: 'categoryId', label: 'Category', type: 'select', resource: 'categories', optionLabel: 'name', required: true, topMargin: '10px', quickAdd: true },
      { name: 'name', label: 'Product Name', required: true },
      { name: 'unit', label: 'Unit', required: true, default: 'Piece' },
      { name: 'unitCost', label: 'Unit Cost', type: 'number', required: true, default: 0 },
      { name: 'masterRate', label: 'Master Rate', type: 'number', required: true, default: 0 },
      { name: 'stitchingRate', label: 'Stitching Rate', type: 'number', required: true, default: 0 },
      { name: 'pressRate', label: 'Press Rate', type: 'number', required: true, default: 0 },
      { name: 'packingRate', label: 'Packing Rate', type: 'number', required: true, default: 0 },
      { name: 'unitRetail', label: 'Unit Retail', type: 'number', required: true, default: 0 },
      { name: 'supplierId', label: 'Supplier', type: 'select', resource: 'suppliers', optionLabel: 'name', quickAdd: true },
      { name: 'standardPrice', label: 'Standard Price', type: 'number', required: true, default: 0 },
      { name: 'reorderLevel', label: 'Reorder Level', type: 'number', required: true, default: 0 },
      { name: 'isRawMaterial', label: 'Raw Material', type: 'boolean', default: false },
      { name: 'isActive', label: 'Active', type: 'boolean', default: true },
      { name: 'productImage', label: 'Product Image', type: 'image', span: 12 }
    ]
  },
  departments: {
    title: 'Department Master',
    singular: 'Department',
    description: 'Production and support department configuration',
    columns: [
      ['code', 'Code'], ['name', 'Name'], ['description', 'Description'],
      ['isProduction', 'Production'], ['isActive', 'Active']
    ],
    fields: [
      { name: 'code', label: 'Department Code', required: true },
      { name: 'name', label: 'Department Name', required: true },
      { name: 'description', label: 'Description', type: 'multiline', span: 12 },
      { name: 'isProduction', label: 'Production Department', type: 'boolean', default: false },
      { name: 'isActive', label: 'Active', type: 'boolean', default: true }
    ]
  },
  designations: {
    title: 'Designation Master',
    singular: 'Designation',
    description: 'Job titles and role designations for employees',
    focusField: 'name',
    columns: [
      ['name', 'Name'], ['isActive', 'Active']
    ],
    fields: [
      { name: 'name', label: 'Designation Name', required: true },
      { name: 'isActive', label: 'Active', type: 'boolean', default: true }
    ]
  },
  expenses: {
    title: 'Expense Heads',
    singular: 'Expense Head',
    description: 'Operational and administrative expense classification',
    columns: [
      ['code', 'Code'], ['name', 'Name'],
      ['isAdministrative', 'Administrative'], ['isActive', 'Active']
    ],
    fields: [
      { name: 'code', label: 'Expense Code', required: true },
      { name: 'name', label: 'Expense Head', required: true },
      { name: 'isAdministrative', label: 'Administrative Expense', type: 'boolean', default: false },
      { name: 'isActive', label: 'Active', type: 'boolean', default: true }
    ]
  },
  orders: {
    title: 'Orders',
    singular: 'Order',
    description: 'Sales order due dates, customers, schools, and production status',
    columns: [
      ['orderNumber', 'Order Number'], ['customerName', 'Customer'], ['schoolName', 'School'],
      ['orderDate', 'Order Date'], ['dueDate', 'Due Date'], ['status', 'Status']
    ],
    fields: [
      { name: 'orderNumber', label: 'Order Number', required: true },
      { name: 'customerId', label: 'Customer', type: 'select', resource: 'customers', optionLabel: 'name', required: true },
      { name: 'schoolId', label: 'School', type: 'select', resource: 'schools', optionLabel: 'name' },
      { name: 'orderDate', label: 'Order Date', type: 'date', required: true },
      { name: 'dueDate', label: 'Due Date', type: 'date' },
      { name: 'status', label: 'Status', type: 'select', required: true, default: 'Pending',
        options: ['Pending', 'Confirmed', 'In Production', 'Completed', 'Cancelled'] },
      { name: 'notes', label: 'Notes', type: 'multiline', span: 12 }
    ]
  },
  production: {
    title: 'Production Jobs',
    singular: 'Production Job',
    description: 'Assign cutting, stitching, press, and packing jobs to employees',
    focusField: 'process',
    searchPlaceholder: 'Search job no, employee, product, or process',
    searchFields: ['jobNumber', 'employeeName', 'employeeCode', 'productName', 'process'],
    filters: [
      {
        name: 'process', label: 'Process',
        options: ['Cutting', 'Stitching', 'Press', 'Packing']
      },
      {
        name: 'status', label: 'Status',
        options: ['Assigned', 'In Progress', 'Completed', 'Cancelled']
      }
    ],
    columns: [
      ['jobNumber', 'Job No'], ['jobDate', 'Date'], ['process', 'Process'],
      ['employeeName', 'Employee'], ['productName', 'Product'],
      ['quantity', 'Qty'], ['status', 'Status']
    ],
    fields: [
      {
        name: 'jobNumber', label: 'Job No', readOnly: true, default: 'Auto (000000-dd/mm/yy)'
      },
      { name: 'jobDate', label: 'Job Date', type: 'date', required: true, defaultToday: true, immutable: true },
      {
        name: 'process', label: 'Process', type: 'select', required: true, default: 'Cutting',
        options: ['Cutting', 'Stitching', 'Press', 'Packing']
      },
      {
        name: 'employeeId', label: 'Employee', type: 'select', resource: 'employees',
        optionLabel: 'name', required: true
      },
      { name: 'productId', label: 'Product', type: 'select', resource: 'products', optionLabel: 'name' },
      { name: 'quantity', label: 'Quantity', type: 'number', required: true, default: 1 },
      {
        name: 'status', label: 'Status', type: 'select', required: true, default: 'Assigned',
        options: ['Assigned', 'In Progress', 'Completed', 'Cancelled']
      },
      { name: 'notes', label: 'Notes', type: 'multiline', span: 12 }
    ]
  },
  inventory: {
    title: 'Inventory',
    singular: 'Inventory Transaction',
    description: 'Immutable stock ledger; corrections use adjustment transactions',
    columns: [
      ['transactionAt', 'Date'], ['sku', 'SKU'], ['productName', 'Product'],
      ['transactionType', 'Type'], ['quantity', 'Quantity'], ['unitCost', 'Unit Cost'],
      ['referenceType', 'Reference']
    ],
    noDelete: true,
    fields: [
      { name: 'productId', label: 'Product', type: 'select', resource: 'products', optionLabel: 'name', required: true, immutable: true },
      { name: 'transactionType', label: 'Transaction Type', type: 'select', required: true, immutable: true,
        options: ['Receipt', 'Issue', 'AdjustmentIn', 'AdjustmentOut'] },
      { name: 'quantity', label: 'Quantity', type: 'number', required: true },
      { name: 'unitCost', label: 'Unit Cost', type: 'number', required: true, default: 0 },
      { name: 'referenceType', label: 'Reference Type' },
      { name: 'referenceId', label: 'Reference ID', type: 'number' }
    ]
  }
};
